import React from 'react';
import { useTheme } from '../context/ThemeContext';

interface LoadingScreenProps {
  message?: string;
  showLogo?: boolean;
  inline?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Loading...",
  showLogo = true,
  inline = false,
}) => {
  const { theme } = useTheme();

  return (
    <div className={inline ? "flex flex-col items-center justify-center p-8 py-16" : "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white dark:bg-gray-900 p-8"}>
      {showLogo && (
        <div className="relative mb-8">
          {/* Restaurant Logo Container */}
          <div 
            className="w-24 h-24 rounded-full flex items-center justify-center shadow-lg"
            style={{
              backgroundColor: theme?.primary || '#4A154B',
              animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            }}
          >
            <span className="text-white text-3xl font-bold">SOG</span>
          </div>
          
          {/* Loading Ring */}
          <div 
            className="absolute inset-0 rounded-full border-4 border-t-transparent animate-spin"
            style={{
              borderColor: `${theme?.primary || '#4A154B'}33`,
              borderTopColor: theme?.primary || '#4A154B',
            }}
          />
        </div>
      )}
      
      {/* Loading Message */}
      <p 
        className="text-lg font-medium animate-pulse"
        style={{ color: theme?.text || '#3E3E3E' }}
      >
        {message}
      </p>
      
      {/* Loading Dots */}
      <div className="flex space-x-1 mt-4">
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: theme?.primary || '#4A154B',
            animationDelay: '0ms'
          }}
        />
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: theme?.primary || '#4A154B',
            animationDelay: '150ms'
          }}
        />
        <div 
          className="w-2 h-2 rounded-full animate-bounce"
          style={{ 
            backgroundColor: theme?.primary || '#4A154B',
            animationDelay: '300ms'
          }}
        />
      </div>
      

    </div>
  );
};

export default LoadingScreen; 